module.exports = __webpack_public_path__ + "img/kort-29.61c00944.jpg";